var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"input-label"},[_c('Description2',{attrs:{"text":_vm.text}})],1),_vm._v(" "),_c('div',{staticClass:"input-label input-label-dot"},[_vm._v(_vm._s(_vm.obligatory ? "*" : ""))])])}
var staticRenderFns = []

export { render, staticRenderFns }